import { Injectable } from "@angular/core";
import { debounceTime, filter, ReplaySubject, Subject, takeUntil } from "rxjs";
import { UiServiceEnvironment } from "./ui-services.environment.service";
import { UiServiceWebSession } from "./ui-services.web-session.service";
import { UiServicesUtils } from "./ui-services.utils.service";
import { HttpClient } from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class UiServicesLogger {
    private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    private buffer: string[] = [];
    private flush = new Subject<LoggerEvents>();

    private _AppName = '';
    public set AppName(value: string) {
      this._AppName = value;
    }

    constructor(private readonly env: UiServiceEnvironment, private readonly utils: UiServicesUtils,
                private readonly session: UiServiceWebSession, private readonly http: HttpClient) { 
      this.flush
          .pipe(debounceTime(5000), filter((event) => event === LoggerEvents.Flush))
          .subscribe(() => this.flushBuffer());
    }

    public onDestroy(): void {
      this.destroyed$.next(true);
      this.destroyed$.complete();
    } 

    public log(message: string): void {
      const uuid = this.session.webConfig?.uuid ?? '';
      message    = `[INFO - ${uuid}] ${message}`;

      this.logMessage(message);
    }

    public error(message: string): void {
      const uuid = this.session.webConfig?.uuid ?? '';
      message    = `[ERROR - ${uuid}] ${message}`;
      
      this.logMessage(message);
    }

    
    private logMessage(message: string): void {
      if(this.env.development) {
        console.log(message);
        return;
      }

      if(this.env.log2Server && this.env.enableDebug) {
        this.buffer.push(message);
        this.flush.next(LoggerEvents.Flush);
      }
    }

    private flushBuffer() {
      const data = this.buffer.splice(0);
      if(data.length === 0) {
        return;
      }
    
      const body = data.map((entry) => (entry + '**###DRCT###**'))
                       .reduce((sum, entry) => (sum += entry), '');
    
      
      const formData = new FormData();
      formData.append("frmData", JSON.stringify({
                                  app_name: this._AppName,
                                  logs: body
                              } ));
      this.http.post(this.utils.builApiUrlWithEnv("drct_logger.php"), formData)
               .pipe(takeUntil(this.destroyed$))
               .subscribe({
                  next: (response: any) => {
                    // TODO: Nothing to do here, just log the response if needed
                  },
                  error: (error: any) => {
                    // TODO: Nothing to do here, just log the error if needed
                  }
                });
    }
}

enum LoggerEvents {
    Flush = 1
}